export default __webpack_public_path__ + "static/media/Shiroo_B.717081cb.png";